<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Operator Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  {{ rentalLabel }} &hyphen; Self Drive Rate (Overrides)
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    {{ rentalLabel }} &hyphen; Self Drive Rate (Overrides)
                    <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set all rental rate.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-accordion table-vehicles table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Provider(s)</th>
                  <th>Vehicle Model</th>
                  <th class="text-center">Type &amp; Class</th>
                  <th class="text-center">Plate No.</th>
                  <!-- <th>Lowest Rate</th> -->
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td :title="printCommaBasedProvider(item.providers)">
                    {{ printProvider(item.providers) }}
                  </td>
                  <td>
                    {{ item.factoryName }} {{ item.brandName }} ({{ item.feature.color }})
                    <span class="year --grey50">
                      {{ item.feature.yearManufactured }} -
                      {{ item.feature.transmission }}
                    </span>
                  </td>
                  <td class="text-center">
                    {{ item.type }}
                    <strong class="--blue25">{{ item.masterClassName }}</strong>
                  </td>
                  <td class="text-center">{{ item.plateNumber }}</td>
                  <!-- <td :class="{ 'sts-danger': !item.hasRate }">
                    {{
                      item.hasRate
                        ? printMinimumRate(item.lowestRate, item.moneyFormat)
                        : "N/A"
                    }}
                  </td> -->
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToCreate || isAllowToUpdate || isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="manageRate(item)"
                      >
                        <span>Manage</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vuemodal" v-if="selectedVehicle">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  {{ rentalLabel }} &hyphen; Self Drive Rate ({{ selectedVehicle.factoryName }}
                  {{ selectedVehicle.brandName }} - {{ selectedVehicle.plateNumber }})
                </h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="row">
                      <!-- Start: Form -->
                      <div class="col-sm-3 divider-right pr-25">
                        <div class="form-group">
                          <label class="required">Rate Type</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error': isSubmitted && $v.model.type.$error,
                            }"
                            placeholder=""
                            label="label"
                            v-model="model.type"
                            :options="types"
                            :clearable="false"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.text"
                          ></v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.type.required"
                            >Type is required</small
                          >
                        </div>
                        <div class="form-group">
                          <label class="required">Enter Duration</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.model.duration.$error,
                            }"
                            type="number"
                            v-model="model.duration"
                            placeholder="Number"
                          />
                          <div v-if="isSubmitted && $v.model.duration.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.duration.required"
                              >Duration is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.duration.minValue"
                              >Min duration is
                              {{ $v.model.duration.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">
                            Rate <span class="--grey50" v-if="selectedVehicle.moneyFormat">({{ selectedVehicle.moneyFormat.currencyCode }})</span>
                          </label>
                          <currency-input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.model.rate.$error,
                            }"
                            autocomplete="off"
                            v-model="model.rate"
                            placeholder="Enter rate"
                            :allow-negative="false"
                            :currency="null"
                            :locale="selectedVehicle.moneyFormat.cultureCode"
                            :precision="selectedVehicle.moneyFormat.numberOfDecimal"
                          />
                          <div v-if="isSubmitted && $v.model.rate.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.required"
                              >Rate is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.minValue"
                              >Min rate is {{ $v.model.rate.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                      <!-- End: Form -->
                      <!-- Start: Table -->
                      <div class="col-sm-9 divider-left pl-20">
                        <div class="table-modal-detail">
                          <div class="table-responsive">
                            <table class="table table-hover table-fix">
                              <thead>
                                <tr>
                                  <th class="number">No</th>
                                  <th>Type</th>
                                  <th class="text-center">Duration</th>
                                  <th class="text-right">
                                    Rate
                                    <span
                                      class="--grey50"
                                      v-if="selectedVehicle.moneyFormat"
                                    >
                                      ({{ selectedVehicle.moneyFormat.currencyCode }})
                                    </span>
                                  </th>
                                  <th class="text-center">Status</th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in rates" :key="item.id">
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td>{{ humanize(item.type) }}</td>
                                  <td class="text-center">{{ item.duration }}</td>
                                  <td class="text-right">
                                    {{
                                      printMoney(item.rate, selectedVehicle.moneyFormat)
                                    }}
                                  </td>
                                  <td class="text-center">
                                    <label class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.isActive"
                                        :disabled="!isAllowToUpdate"
                                        @change="changeStatus(item)"
                                      />
                                      <span class="pl-5 font-weight-normal v-align-middle">
                                        {{ item.isActive ? "Active" : "Inactive" }}
                                      </span>
                                    </label>
                                  </td>
                                  <td class="text-center">
                                    <div class="button-action-wrapper">
                                      <button
                                        v-if="isAllowToUpdate"
                                        class="btn btn-default"
                                        type="button"
                                        @click="bindModel(item)"
                                      >
                                        <span>Edit</span>
                                      </button>
                                      <button
                                        v-if="isAllowToDelete"
                                        class="btn btn-default"
                                        type="button"
                                        @click="confirmDelete(item)"
                                      >
                                        <i class="ic-close"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- End: Table -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import buyingTariffRentalRateService from "@/services/master/buyingTariff/buyingTariffOverriddenRentalRateService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      types: [],
      rentalLabel: null,
      allPermissions: [],
      selectedVehicle: null,
      isUpdate: false,
      isItemHasBeenModified: false,
      itemToBeDeleted: null,
      items: [],
      rates: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        type: { required },
        duration: { required, minValue: minValue(0) },
        rate: { required, minValue: minValue(0) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);
    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getCommon();
    }
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("overridden-buying-rental-selfdrive-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    async closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.vuemodal).modal("hide");
      if (this.isItemHasBeenModified) {
        await this.getAll();
      }
    },
    bindModel(item) {
      this.isUpdate = true;
      this.resetValidations();
      this.model = Object.assign({}, item);
    },
    reset() {
      this.isUpdate = false;
      this.resetValidations();
      this.model = {};
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        filter += "&data=selfdrive";
        const response = await buyingTariffRentalRateService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCommon() {
      const common = await buyingTariffRentalRateService.getCommon(true);
      this.types = common.types;

      for (let i = 0; i < this.types.length; i++) {
        const type = this.types[i];
        type.label = this.humanize(type.text);
      }
    },
    async getRates(vehicleId) {
      this.rates = await buyingTariffRentalRateService.getRates(vehicleId, true);
    },
    async manageRate(item) {
      try {
        this.isLoading = true;
        this.isItemHasBeenModified = false;
        this.selectedVehicle = item;
        await this.getRates(item.vehicleId);
        this.openModal({});
        this.isUpdate = false;
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.rate = parseFloat(this.model.rate);
        this.model.duration = parseInt(this.model.duration);
        if (this.isUpdate) {
          await buyingTariffRentalRateService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        } else {
          this.model.isSelfDrive = true;
          this.model.vehicleId = this.selectedVehicle.vehicleId;
          await buyingTariffRentalRateService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        }
        this.reset();
        await this.getRates(this.selectedVehicle.vehicleId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await buyingTariffRentalRateService.update(item);
        this.$notification.success("Successfully updated.", { title: "Success" });
        await this.getRates(this.selectedVehicle.vehicleId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await buyingTariffRentalRateService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        await this.getRates(this.selectedVehicle.vehicleId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printMoney(value, moneyFormat) {
      if (moneyFormat) {
        return new Intl.NumberFormat(moneyFormat.cultureCode, {
          style: "currency",
          currency: moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: moneyFormat.numberOfDecimal,
        })
          .format(value)
          .replace(/[a-z]{3}/i, "")
          .trim();
      }
      return value;
    },
    printMinimumRate(item, moneyFormat) {
      return `${moneyFormat.currencyCode} ${this.printMoney(
        item.rate,
        moneyFormat
      )} per ${item.duration} ${item.type.toLowerCase().replace("per", "")}`;
    },
    printProvider(item) {
      return item.length === 1 ? item[0].providerName : `${item.length} providers`;
    },
    printCommaBasedProvider(item) {
      return item.map((x) => x.providerName).join(", ");
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/OverriddenRentalSelfDriveRate.vue